import { render, staticRenderFns } from "./ReturnDrqItems.vue?vue&type=template&id=b6dc511e&scoped=true&"
import script from "./ReturnDrqItems.vue?vue&type=script&lang=js&"
export * from "./ReturnDrqItems.vue?vue&type=script&lang=js&"
import style0 from "./ReturnDrqItems.vue?vue&type=style&index=0&id=b6dc511e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6dc511e",
  null
  
)

export default component.exports